import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import MediaSinglePersonaDetail from './MediaSinglePersonaDetail';
import { getHighestIndexOrPercentBrands } from '../../../util/Insight360Utils';

class MediaSinglePersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'index',
    };
  }

  resizeArray = (arr, newSize, defaultValue) => {
    while (newSize > arr.length) arr.push(defaultValue);
  }

  fillArray(brandsOrMedia) {
    if (brandsOrMedia.length === 0) {
      this.resizeArray(brandsOrMedia, 1, {
        iconCategory: 'N/A',
        brandCategory: 'N/A',
        brandLabel: 'N/A',
        icon: 'clear-field-icon_190-190-190.png',
        index: 'N/A',
        weighted: 'N/A',
        sample: 'N/A',
        pct: 'N/A',
      });
      return brandsOrMedia;
    }
    return brandsOrMedia;
  }

  render() {
    let mediaData = [];
    let mediaGroupList = [];
    let highestIndex = 0;
    if (this.props.media !== undefined) {
      mediaData = this.props.media;
      mediaGroupList = mediaData[0].brandList;
      if (mediaGroupList.length === 0) {
        mediaGroupList = this.fillArray(mediaGroupList);
      }
      highestIndex = getHighestIndexOrPercentBrands(
        mediaGroupList,
        this.state.selectedRadioButton,
      );
    }
    return (
      <div className="row fullwidth mediaCardPdf" id="">
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
        <div
          className="large-10 medium-10 small-10 columns"
          id="mediaSinglePersona"
        >
          <div className="row fullwidth">
            {mediaGroupList.length > 0 &&
              mediaGroupList.map((details, i) => (<div className="row fullwidth" key={`media-s${i}`}>
                <div className="columns large-12 small-12 medium-12">
                  <MediaSinglePersonaDetail
                    highestIndex={highestIndex}
                    selectedTab={this.props.selectedTab}
                    insight360studyInfo={this.props.insight360studyInfo}
                    personaIndex={0}
                    brandsDetail={details}
                    selectedIcon={_.camelCase(
                      details.icon.replace('.png', ''),
                    )}
                  />
                </div>
              </div>
              )
              )}
          </div>
        </div>
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
      </div>
    );
  }
}

MediaSinglePersona.propTypes = {
  media: PropTypes.arrayOf(PropTypes.object),
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(MediaSinglePersona);
